import { ApiError, ErrorHandlingConfig, handleApiError } from '@/handleApiError'
import { PiniaColada, PiniaColadaOptions, PiniaColadaQueryHooksPlugin } from '@pinia/colada'

type OnErrorConfig = {
  defaultConfigParams?: Partial<ErrorHandlingConfig>
  specificConfigParams?: Array<Partial<ErrorHandlingConfig>>
}

type SfMeta = {
  onError: OnErrorConfig | undefined
}

type PiniaColadaInfiniteQueryResult<T> = {
  pages: T[]
  pageParams: unknown[]
}

const options: PiniaColadaOptions = {
  queryOptions: {
    // change the stale time for all queries to 5 minutes
    staleTime: 5 * 60 * 1000 // 5 minutes
  },
  mutationOptions: {
    // add global mutation options here
  },
  plugins: [
    PiniaColadaQueryHooksPlugin({
      onError: (error, entry) => {
        const meta = entry.meta
        if (meta.onError) {
          const { defaultConfigParams, specificConfigParams } = meta.onError
          handleApiError(error as ApiError, defaultConfigParams, ...(specificConfigParams ?? []))
        } else {
          handleApiError(error as ApiError)
        }
      }
    })
  ]
}

export { PiniaColada, options }
export type { SfMeta, OnErrorConfig, PiniaColadaInfiniteQueryResult }
